import { AsciiText } from '../framework/AsciiText';
export class NovoTouch {
    constructor(socket) {
        this.socket = socket;
        this.power = false;
        this.videoInput = 6; // HDMI 1
        this.volume = 50;
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'powerQuery',
                regExp: /\xAA\xBB\xCC\x01\x02\x00[\s\S]\xDD\xEE/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0x80, this.power ? 0 : 1, 0]));
                },
            },
            {
                name: 'powerSet',
                regExp: /\xAA\xBB\xCC\x01([\s\S])\x00[\s\S]\xDD\xEE/,
                callback: (match) => {
                    this.power = match[1].charCodeAt(0) === 0;
                    this.socket.send(this.makeCommand([0x80, this.power ? 0 : 1, 0]));
                },
            },
            {
                name: 'uiNavigation',
                regExp: /\xAA\xBB\xCC\x07([\s\S])\x00[\s\S]\xDD\xEE/i,
                callback: (match) => {
                    // Need to confirm acknowledgement from navigation controls
                    this.socket.send(this.makeCommand([0x07, parseInt(match[1], 16), 0]));
                },
            },
            {
                name: 'videoInputQuery',
                regExp: /\xAA\xBB\xCC\x02\x00\x00[\s\S]\xDD\xEE/i,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0x81, this.videoInput, 0x00]));
                },
            },
            {
                name: 'videoInputSet',
                regExp: /\xAA\xBB\xCC\x02([\s\S])\x00[\s\S]\xDD\xEE/i,
                callback: (match) => {
                    this.videoInput = match[1].charCodeAt(0);
                    this.socket.send(this.makeCommand([0x81, this.videoInput, 0]));
                },
            },
            {
                name: 'volumeMuteQuery',
                regExp: /\xAA\xBB\xCC\x03\x03\x00[\s\S]\xDD\xEE/i,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0x82, 0x01, this.volumeMute ? 0 : 1]));
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /\xAA\xBB\xCC\x03\x01([\s\S])[\s\S]\xDD\xEE/i,
                callback: (match) => {
                    this.volumeMute = match[1].charCodeAt(0) === 0;
                    this.socket.send(this.makeCommand([0x82, 0x01, this.volumeMute ? 0 : 1]));
                },
            },
            {
                name: 'volumeQuery',
                regExp: /\xAA\xBB\xCC\x03\x02\x00[\s\S]\xDD\xEE/i,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0x82, 0x00, this.volume]));
                },
            },
            {
                name: 'volumeSet',
                regExp: /\xAA\xBB\xCC\x03\x00([\s\S])[\s\S]\xDD\xEE/i,
                callback: (match) => {
                    this.volume = match[1].charCodeAt(0);
                    this.socket.send(this.makeCommand([0x82, 0x00, this.volume]));
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    // No response to an invalid command
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const vi of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const viNum = vi.code.charCodeAt(0) - 0x30;
            if (this.videoInput === viNum)
                return;
            if (lowestCode === undefined || viNum < lowestCode) {
                lowestCode = viNum;
            }
        }
        this.videoInput = lowestCode !== null && lowestCode !== void 0 ? lowestCode : 6;
    }
    makeCommand(data) {
        const bytes = [0xaa, 0xbb, 0xcc];
        bytes.push(...data);
        const checksum = data.reduce((a, b) => a + b);
        bytes.push(checksum & 0x00ff, 0xdd, 0xee);
        return AsciiText.decode(bytes);
    }
}
NovoTouch.emulatorType = 'socketEmulator';
NovoTouch.key = '-KtY-ZdRD_Qao8JBne3Y';
